// Catégories & services partagés pour la fonctionnalité « Nos réalisations »

export const CATEGORIES = [
  { key: "maisons", label: "Construction de maisons" },
  { key: "immeubles", label: "Immeubles" },
  { key: "renovation", label: "Rénovation" },
  { key: "genie-civil", label: "Génie civil" },
  { key: "gestion", label: "Gestion immobilière" },
  { key: "en-cours", label: "Projets en cours" },
];

export const CATEGORY_LABEL = CATEGORIES.reduce((acc, c) => ({ ...acc, [c.key]: c.label }), {});

export const categoryLabel = (key) => CATEGORY_LABEL[key] || "Réalisation";

export const SERVICES = [
  "Construction",
  "Maçonnerie",
  "Béton armé",
  "Terrassement",
  "Gros œuvre",
  "Électricité",
  "Plomberie",
  "Menuiserie",
  "Carrelage",
  "Peinture",
  "Étanchéité",
  "Finitions",
];

export const STATUSES = ["Terminé", "En cours", "Livré"];
